<template>
  <main class="container alianca-content alianca-content-seuplano">
    <section class="row">
      <div class="main-content main-content-seuplano col-12">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="true"
          class="overlay-load"
          :z-index="9999"
        >
        </loading>

        <transition name="fade">
          <div id="seu-plano">
            <div id="header-seu-plano" class="header-seu-plano">
              <div class="container header-plano-content" v-if="loadingcontent">
                <div class="seletor-entidade">
                  Aguarde:
                  <b-button class="entidade-select" style="margin-left: -15px"
                    >Buscando seu plano...</b-button
                  >
                  <span class="txt-seuplano-pequeno" style="padding-left: 40px"
                    >Filtrar:</span
                  >
                  <b-button class="filter-select"></b-button>
                  <b-button class="filter-select"></b-button>
                  <b-button
                    class="filter-select"
                    style="margin-right: 10px"
                  ></b-button>
                  <span class="txt-seuplano-pequeno">Ordenar:</span
                  ><b-button class="filter-select"></b-button>
                </div>

                <div class="seletor-entidade-mobile" style="display: none">
                  <span>Filtrar:</span>
                  <b-button
                    class="filter-select filter-select-mobile"
                  ></b-button>
                </div>
              </div>

              <div class="container header-plano-content" v-else>
                <div class="seletor-entidade">
                  {{ tipoorgaoentidade }}:
                  <b-button
                    v-if="entidadeorgaoinfo.length > 0"
                    class="entidade-select"
                    style="margin-left: -15px"
                    v-b-modal.modal-saibamais
                    >{{ reduceText(nomeorgaoentidade, 19) }}
                    <font-awesome-icon icon="sort-down" class="icon-sort-down"
                  /></b-button>
                  <span v-else style="color: #000000">
                    <strong v-if="nomeorgaoentidade != null">{{ nomeorgaoentidade.descricao }}</strong>
                    <strong></strong>
                  </span>
                  <span class="txt-seuplano-pequeno" style="padding-left: 40px"
                    >Filtrar:</span
                  >
                  <b-button
                    class="filter-select"
                    v-b-modal.modal-filtro-operadora
                    >{{ filteroperadora }}
                    <img src="@/assets/arrow-down.svg" alt="Mostrar operadoras"
                  /></b-button>
                  <b-button
                    class="filter-select"
                    v-b-modal.modal-filtro-cobertura
                    >{{ filtercobertura }}
                    <img src="@/assets/arrow-down.svg" alt="Mostrar coberturas"
                  /></b-button>
                  <b-button
                    class="filter-select"
                    style="margin-right: 10px"
                    v-b-modal.modal-filtro-more
                    >{{ filtermore }}
                    <img
                      src="@/assets/arrow-down.svg"
                      alt="Mostrar mais filtros"
                  /></b-button>
                  <span class="txt-seuplano-pequeno">Ordenar:</span
                  ><b-button
                    class="filter-select"
                    @click="
                      ativaOrdenacao();
                      orderlista();
                    "
                    >{{ filtervalor }}
                    <font-awesome-icon icon="sort-down" class="icon-sort-down"
                  /></b-button>
                </div>

                <div class="seletor-entidade-mobile" style="display: none">
                  <span>Filtrar:</span>
                  <b-button
                    class="filter-select filter-select-mobile"
                    @click="filtrosmobile = !filtrosmobile"
                    >Ver todas opções de filtro</b-button
                  >
                </div>
              </div>

              <b-modal
                id="modal-saibamais"
                v-if="!loadingcontent && statusorgaoentidadewp"
              >
                <template #modal-header="{ close }">
                  <div style="margin: 0">
                    <h5 class="title-modal">Saiba mais</h5>
                    <div style="margin: 0; margin-left: 16px">
                      <b-button
                        class="filter-select more-entidade"
                        @click="changeActiveEntidadeOrgao(1)"
                        >Convênio
                        <img
                          src="@/assets/arrow-down.svg"
                          alt="Informações da entidade"
                      /></b-button>
                      <b-button
                        class="filter-select more-entidade"
                        @click="changeActiveEntidadeOrgao(2)"
                        >Planos
                        <img
                          src="@/assets/arrow-down.svg"
                          alt="Informações dos planos"
                      /></b-button>
                      <b-button
                        class="filter-select more-entidade"
                        @click="changeActiveEntidadeOrgao(3)"
                        >Carência
                        <img
                          src="@/assets/arrow-down.svg"
                          alt="Informações de carência"
                      /></b-button>
                      <b-button
                        class="filter-select more-entidade"
                        @click="changeActiveEntidadeOrgao(4)"
                        >Operadoras
                        <img
                          src="@/assets/arrow-down.svg"
                          alt="Informações das operadoras conveniadas"
                      /></b-button>
                      <b-button
                        class="filter-select more-entidade"
                        @click="changeActiveEntidadeOrgao(5)"
                        style="width: 181px"
                        >Quem pode aderir
                        <img
                          src="@/assets/arrow-down.svg"
                          alt="Informações de quem pode aderir"
                      /></b-button>
                    </div>
                  </div>
                  <div style="margin: 0">
                    <b-button
                      class="close btn-close btn-modais-nohover"
                      aria-label="Close"
                      @click="close()"
                      >×</b-button
                    >
                  </div>
                </template>
                <div>
                  <div v-if="activeentidadeorgao === 1">
                    <div class="entidade-header">
                      <img
                        style="width: 150px"
                        :src="entidadeorgaoinfo[0].logo"
                      />
                      <h3 style="margin-left: 28px">
                        {{ entidadeorgaoinfo[0].titulo }}, {{ endcidade }},
                        {{ enduf }}
                      </h3>
                    </div>
                    <div v-html="entidadeorgaoinfo[0].convenio"></div>
                  </div>
                  <div
                    v-if="activeentidadeorgao === 2"
                    v-html="entidadeorgaoinfo[0].planos"
                  ></div>
                  <div
                    v-if="activeentidadeorgao === 3"
                    v-html="entidadeorgaoinfo[0].carencia"
                  ></div>
                  <div v-if="activeentidadeorgao === 4" class="row">
                    <div
                      class="col col-sm-2 div-operadora div-operadora-saibamais"
                      v-for="operadora in operadoras"
                      :key="operadora.operadoraprotheusid"
                    >
                      <div>
                        <img
                          style="width: 150px"
                          :src="
                            listaOperadoras[operadora.operadoraprotheusid]
                              .LOGO_OPERADORA
                          "
                        />
                        <div
                          class="ans-selo-div"
                          style="background: #fff; margin-top: 0 !important"
                        >
                          <span class="ans-selo-op"
                            >ANS - Nº
                            {{
                              listaOperadoras[operadora.operadoraprotheusid].ANS
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="activeentidadeorgao === 5"
                    v-html="entidadeorgaoinfo[0].quempodeaderir"
                  ></div>
                </div>
                <template #modal-footer><span></span></template>
              </b-modal>
              <b-modal id="modal-filtro-operadora">
                <template #modal-header="{ close }">
                  <h5 class="title-modal">
                    Encontre o seu plano pelas
                    <span style="color: #a01d22">operadoras disponíveis</span>
                  </h5>
                  <b-button
                    class="close btn-close btn-modais-nohover"
                    aria-label="Close"
                    @click="
                      verificaPlanos(true, true);
                      close();
                    "
                    >×</b-button
                  >
                </template>
                <div class="row">
                  <div
                    class="col col-sm-2 div-operadora"
                    v-for="(operadora, index) in operadoras"
                    :key="operadora.operadoraprotheusid"
                  >
                    <div
                      class="div-operadora-selector"
                      :class="{
                        'div-operadora-selector-on':
                          selectedoperadoras[index].selected === true,
                      }"
                    >
                      <div class="img-operadora">
                        <img
                          style="width: 88px"
                          :src="
                            listaOperadoras[operadora.operadoraprotheusid]
                              .LOGO_OPERADORA
                          "
                        />
                        <div
                          class="ans-selo-div"
                          style="background: #fff; margin-top: 0 !important"
                        >
                          <span class="ans-selo-op"
                            >ANS - Nº
                            {{
                              listaOperadoras[operadora.operadoraprotheusid].ANS
                            }}</span
                          >
                        </div>
                      </div>
                      <div
                        class="check-area"
                        :class="{
                          'check-area-on':
                            selectedoperadoras[index].selected === true,
                        }"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :id="operadora.slug"
                          v-model="selectedoperadoras[index].selected"
                        />
                        {{ reduceText(operadora.operadoraNome, 20) }}
                      </div>
                    </div>
                  </div>
                </div>
                <template #modal-footer="{ ok }">
                  <b-button
                    class="btn-alianca btn-modais"
                    @click="
                      verificaPlanos(true, true);
                      ok();
                    "
                    >Filtrar operadoras</b-button
                  >
                </template>
              </b-modal>
              <b-modal id="modal-filtro-cobertura">
                <template #modal-header="{ close }">
                  <h5 class="title-modal">
                    Escolha as suas
                    <span style="color: #a01d22">coberturas</span>
                  </h5>
                  <b-button
                    class="close btn-close btn-modais-nohover"
                    aria-label="Close"
                    @click="
                      verificaPlanos(true, true);
                      close();
                    "
                    >×</b-button
                  >
                </template>
                <div class="row">
                  <div
                    v-for="(filtro, i) in filtroscobertura"
                    :key="i"
                    class="col col-sm-12 col-md-2 check-filter"
                    :class="{
                      'checked-filter': filtroscobertura[i].selected === true,
                    }"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input"
                      v-model="filtroscobertura[i].selected"
                    />
                    {{ filtroscobertura[i].valor }}
                  </div>
                </div>
                <template #modal-footer="{ ok }">
                  <b-button
                    class="btn-alianca btn-modais"
                    @click="
                      verificaPlanos(true, true);
                      ok();
                    "
                    >Filtrar coberturas</b-button
                  >
                </template>
              </b-modal>
              <b-modal id="modal-filtro-hospital">
                <template #modal-header="{ close }">
                  <h5 class="title-modal">
                    Filtrar por <span style="color: #a01d22">hospitais</span>
                  </h5>
                  <b-button
                    class="close btn-close btn-modais-nohover"
                    aria-label="Close"
                    @click="
                      verificaPlanos(true, true);
                      close();
                    "
                    >×</b-button
                  >
                </template>
                <div class="row filtro-texto">
                  <div class="content-filtro-texto">
                    <p>Digite o nome do hospital:</p>
                    <b-form-input
                      v-model="textofiltrohospitais"
                      placeholder="Buscar hospital de sua preferencia"
                    ></b-form-input>
                  </div>
                </div>
                <div class="row content-hospitais">
                  <div
                    v-for="(filtro, i) in filtroshospitais"
                    :key="i"
                    class="col-md-3 col-sm-12 check-filter"
                    :class="{
                      'checked-filter': filtroshospitais[i].selected === true,
                    }"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input"
                      v-model="filtroshospitais[i].selected"
                    />
                    {{ filtroshospitais[i].valor }}
                  </div>
                </div>
                <template #modal-footer="{ ok }">
                  <b-button
                    class="btn-alianca btn-modais"
                    @click="
                      verificaPlanos(true, true);
                      ok();
                    "
                    >Filtrar hospitais</b-button
                  >
                </template>
              </b-modal>
              <b-modal id="modal-filtro-more">
                <template #modal-header="{ close }">
                  <h5 class="title-modal">
                    Escolha mais opções de
                    <span style="color: #a01d22">filtros</span>
                  </h5>
                  <b-button
                    class="close btn-close btn-modais-nohover"
                    aria-label="Close"
                    @click="
                      verificaPlanos(true, true);
                      close();
                    "
                    >×</b-button
                  >
                </template>
                <div class="mais-filtros-planos">
                  <div style="display: flex">
                    <div class="div-text-filter" style="margin-right: 10px">
                      <h4 class="text-filter">Tipo de Plano:</h4>
                    </div>
                    <div
                      v-for="(filtro, i) in filtrostipoplano"
                      :key="i"
                      class="col col-sm-2 check-filter"
                      :class="{
                        'checked-filter': filtrostipoplano[i].selected === true,
                      }"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="filtrostipoplano[i].selected"
                      />
                      {{ filtrostipoplano[i].valor }}
                    </div>
                  </div>
                  <div style="display: flex">
                    <div class="div-text-filter">
                      <h4 class="text-filter">Coparticipação:</h4>
                    </div>
                    <div
                      v-for="(filtro, i) in filtroscoparticipacao"
                      :key="i"
                      class="col col-sm-2 check-filter"
                      :class="{
                        'checked-filter':
                          filtroscoparticipacao[i].selected === true,
                      }"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="filtroscoparticipacao[i].selected"
                      />
                      {{ filtroscoparticipacao[i].valor }}
                    </div>
                  </div>
                  <div style="display: flex">
                    <div class="div-text-filter">
                      <h4 class="text-filter">Acomodação:</h4>
                    </div>
                    <div
                      v-for="(filtro, i) in filtrosacomodacao"
                      :key="i"
                      class="col col-sm-2 check-filter"
                      :class="{
                        'checked-filter':
                          filtrosacomodacao[i].selected === true,
                      }"
                      style="margin-left: 33px"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="filtrosacomodacao[i].selected"
                      />
                      {{ filtrosacomodacao[i].valor }}
                    </div>
                  </div>
                  <div style="display: flex">
                    <div class="div-text-filter">
                      <h4 class="text-filter">Preço:</h4>
                    </div>
                    <div class="col col-sm-12 range-slider">
                      <vue-slider
                        width="400px"
                        v-model="precorange"
                        @change="disableStartRange()"
                      ></vue-slider>
                      <small
                        >De
                        <b
                          >R$
                          {{
                            formatMoney(
                              checaValorRange(
                                fatormultiplicacaorange * precorange[0]
                              )
                            )
                          }}</b
                        >
                        Até
                        <b
                          >R$
                          {{
                            formatMoney(
                              checaValorRange(
                                fatormultiplicacaorange * precorange[1]
                              )
                            )
                          }}</b
                        ></small
                      >
                    </div>
                  </div>
                </div>
                <template #modal-footer="{ ok }">
                  <b-button
                    class="btn-alianca btn-modais"
                    @click="
                      verificaPlanos(true, true);
                      ok();
                    "
                    >Filtrar</b-button
                  >
                </template>
              </b-modal>
            </div>

            <b-container
              id="content-seu-plano"
              class="content-seu-plano"
            >
              <b-row>
                <b-col
                  md="4"
                  sm="12"
                  v-for="(plano, index) in planosfiltered.slice(
                    0,
                    pagination + 1
                  )"
                  :key="plano.planoid"
                  ><!-- in planosfiltered -->
                  <div v-if="listaOperadoras[operadoras[plano.frontoperadoraid].operadoraprotheusid]" class="card-plano card-plano-content">
                    <!-- v-if="index <= pagination" -->
                    <div class="row sec1-plano">
                      <div class="col-sm-3 sec1-plano-img">
                        <img
                          style="width: 88px"
                          :src="
                            listaOperadoras[
                              operadoras[plano.frontoperadoraid]
                                .operadoraprotheusid
                            ].LOGO_OPERADORA
                          "
                        />
                        <div
                          class="ans-selo-div"
                          style="background: #fff; margin-top: 0 !important"
                        >
                          <span class="ans-selo-op"
                            >ANS - Nº
                            {{
                              listaOperadoras[
                                operadoras[plano.frontoperadoraid]
                                  .operadoraprotheusid
                              ].ANS
                            }}</span
                          >
                        </div>
                      </div>
                      <div class="sec1-plano-texto col-sm-9">
                        <p>
                          <b>{{ "PLANO " + plano.operadoraid + " - " }}</b>
                          {{ reduceText(plano.descplano, 60) }}
                        </p>
                      </div>
                    </div>
                    <div class="row sec2-plano">
                      <div class="col-sm-12 sec2-item-detalhe">
                        <div class="sec2-icon-fa">
                          <font-awesome-icon
                            icon="map-marker-alt"
                            class="icon-map-marker-alt"
                          />
                        </div>
                        <div class="sec2-detalhes-plano">
                          <span>Cobertura: </span>
                          {{ getAbrangencia(plano.cobertura) }}
                        </div>
                      </div>
                      <div class="col-sm-12 sec2-item-detalhe">
                        <div class="sec2-icon-fa">
                          <font-awesome-icon icon="bed" class="icon-bed" />
                        </div>
                        <div class="sec2-detalhes-plano">
                          <span>Acomodação: </span>
                          {{ getAcomodacao(plano.acomodacao) }}
                        </div>
                      </div>
                      <div class="col-sm-12 sec2-item-detalhe">
                        <div class="sec2-icon-fa">
                          <font-awesome-icon
                            icon="user-friends"
                            class="icon-user-friends"
                          />
                        </div>
                        <div class="sec2-detalhes-plano">
                          <span>Coparticipação: </span>
                          {{ plano.coparticipacao == "0" ? "NÃO" : "SIM" }}
                        </div>
                      </div>
                      <div
                        class="col-sm-12 sec2-item-detalhe"
                        style="
                          justify-content: space-between;
                          padding-right: 3px;
                        "
                        @click="
                          obterDetalhes(plano.planoid);
                        "
                        v-b-modal="'modal-filtro-plano-' + index"
                      >
                        <div
                          class="div-btn-vertodosdetalhes"
                          style="margin: 0; display: inherit"
                        >
                          <div class="sec2-detalhes-plano">
                            Ver todos detalhes do plano
                          </div>
                          <div style="margin: 0; margin-top: 5px">
                            <img
                              src="@/assets/arrow-right-red.svg"
                              alt="Mostrar detalhes do plano"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row sec3-plano">
                      <h4>
                        R$
                        <strong>{{
                          formatMoney(
                            calculaPrecoReal(plano.valor - plano.valor_aux)
                          )
                        }}</strong
                        ><span>/mês</span>
                      </h4>
                    </div>
                    <div class="row sec4-plano">
                      <b-button
                        @click="
                          selectPlano(plano.planoid, plano.planoidprotheus)
                        "
                        >COMPRAR PLANO</b-button
                      >
                    </div>
                    <div class="row sec5-plano">
                      <h5>Comparar plano</h5>
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :id="'checkbox-plano' + plano.planoid"
                        v-model="selectedplanos[plano.planoid].selected"
                        :disabled="countselectedplanos > 1"
                        @change="verifyComparaPlanos(plano.planoid)"
                      />
                    </div>
                  </div>
                  <b-modal
                    :id="'modal-filtro-plano-' + index"
                    class="modal-detalhe-plano"
                    v-if="index <= pagination"
                  >
                    <template #modal-header="{ close }">
                      <h5 class="title-modal">
                        Detalhes do <span style="color: #a01d22">plano</span>
                      </h5>
                      <b-button
                        class="close btn-close btn-modais-nohover"
                        aria-label="Close"
                        @click="close()"
                        >×</b-button
                      >
                    </template>
                    <div class="container modal-plano">
                      <div class="row row-modal-plano-header">
                        <div class="col-sm-4 col-modal-plano-header">
                          <h4>Plano escolhido:</h4>
                        </div>
                        <div class="col-sm-4 col-modal-plano-header">
                          <h4>Informações:</h4>
                        </div>
                        <div class="col-sm-4 col-modal-plano-header">
                          <h4>Resumo do pedido:</h4>
                        </div>
                      </div>
                      <div class="row row-modal-plano">
                        <div
                          class="col-sm-4 col-modal-plano"
                          style="padding-left: 0; padding-top: 0"
                        >
                          <div
                            class="row sec1-plano"
                            style="padding-left: 0; padding-top: 0"
                          >
                            <div class="col-sm-3 sec1-plano-img">
                              <img
                                style="width: 150px"
                                :src="
                                  listaOperadoras[
                                    operadoras[plano.frontoperadoraid]
                                      .operadoraprotheusid
                                  ].LOGO_OPERADORA
                                "
                              />
                              <div
                                class="ans-selo-div"
                                style="
                                  background: #fff;
                                  margin-top: 0 !important;
                                "
                              >
                                <span class="ans-selo-op">
                                  ANS - Nº
                                  {{
                                    listaOperadoras[
                                      operadoras[plano.frontoperadoraid]
                                        .operadoraprotheusid
                                    ].ANS
                                  }}
                                </span>
                              </div>
                            </div>
                            <div
                              class="col-sm-12 sec1-plano-texto"
                              style="padding: 0"
                            >
                              {{ plano.descplano }}
                            </div>
                            <div
                              class="col-sm-12 sec1-plano-texto"
                              style="padding: 0; text-align: justify; margin-top:15px; font-size: 12px;line-height: 17px;"
                            >
                              A fim de facilitar sua análise, esta Administradora disponibiliza tabela referência do auxílio saúde dos Órgãos os quais possui convênio. Mas, fique ATENTO ao processo necessário para requerer junto à área de Recursos Humanos do seu Órgão, pois cada órgão/empresa pública possui política, prazo distinto para solicitação e disponibilização do auxílio saúde.
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 col-modal-plano">
                          <div class="sec2-plano">
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="map-marker-alt"
                                  class="icon-map-marker-alt"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Cobertura: </span>
                                {{ getAbrangencia(plano.cobertura) }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="bed"
                                  class="icon-bed"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Acomodação: </span>
                                {{ getAcomodacao(plano.acomodacao) }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user-friends"
                                  class="icon-user-friends"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Coparticipação: </span>
                                {{
                                  plano.coparticipacao == "0" ? "NÃO" : "SIM"
                                }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user"
                                  class="icon-user"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Idade Titular: </span>
                                {{
                                  calculateAge(
                                    datanasc.substr(6, 4) +
                                      "/" +
                                      datanasc.substr(3, 2) +
                                      "/" +
                                      datanasc.substr(0, 2)
                                  ) + " anos"
                                }}
                              </div>
                            </div>
                            <div
                              v-if="dependentes != null"
                              class="sec2-item-detalhe"
                            >
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user"
                                  class="icon-user"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Quantidade de dependentes: </span>
                                {{ dependentes.length }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="dollar-sign"
                                  class="icon-dollar-sign"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Valor do plano: </span>
                                {{ formatMoney(plano.valor) }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <svg
                                  width="16"
                                  height="18"
                                  viewBox="0 0 16 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.50006 3.9C10.2801 3.9 10.9401 4.75 11.0001 6H13.2101C13.1401 4.28 12.0901 2.7 10.0001 2.19V0H7.00006V2.16C6.47006 2.28 5.97006 2.46 5.52006 2.7L6.99006 4.17C7.40006 4 7.90006 3.9 8.50006 3.9ZM1.33006 1.06L0.0600586 2.33L3.50006 5.77C3.50006 7.85 5.06006 8.98 7.41006 9.68L10.9201 13.19C10.5801 13.67 9.87006 14.1 8.50006 14.1C6.44006 14.1 5.63006 13.18 5.52006 12H3.32006C3.44006 14.19 5.08006 15.42 7.00006 15.83V18H10.0001V15.85C10.9601 15.67 11.8201 15.3 12.4501 14.73L14.6701 16.95L15.9401 15.68L1.33006 1.06Z"
                                    fill="#B34A4E"
                                  />
                                </svg>
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Auxilio: </span>
                                {{ formatMoney(plano.valor_aux) }}
                              </div>
                            </div>
                            <div
                              class="sec2-item-detalhe"
                              style="
                                justify-content: space-between;
                                padding-right: 40px;
                              "
                            >
                              <div style="margin: 0; display: inherit">
                                <div
                                  class="sec2-icon-fa"
                                  style="margin-right: 20px"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.41 16.09V18H8.74V16.07C7.03 15.71 5.58 14.61 5.47 12.67H7.43C7.53 13.72 8.25 14.54 10.08 14.54C12.04 14.54 12.48 13.56 12.48 12.95C12.48 12.12 12.04 11.34 9.81 10.81C7.33 10.21 5.63 9.19 5.63 7.14C5.63 5.42 7.02 4.3 8.74 3.93V2H11.41V3.95C13.27 4.4 14.2 5.81 14.26 7.34H12.3C12.25 6.23 11.66 5.47 10.08 5.47C8.58 5.47 7.68 6.15 7.68 7.11C7.68 7.95 8.33 8.5 10.35 9.02C12.37 9.54 14.53 10.41 14.53 12.93C14.52 14.76 13.15 15.76 11.41 16.09Z"
                                      fill="#1DA090"
                                    />
                                  </svg>
                                </div>
                                <div class="sec3-plano" style="border: none">
                                  <h4>
                                    R$
                                    <strong>{{
                                      formatMoney(
                                        calculaPrecoReal(
                                          plano.valor - plano.valor_aux
                                        )
                                      )
                                    }}</strong
                                    ><span>/mês</span>
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-4 col-modal-plano"
                          style="overflow: auto; max-height: 320px"
                        >
                          <div class="sec2-plano">
                            <div v-if="exibeopcionais">
                              <span
                                @click="obterDetalhesAnalisado = 1"
                                class="call-add-opcionais"
                                v-b-modal="'modal-opcionais-plano-' + index"
                                ><img
                                  src="@/assets/addopcionais.svg"
                                  alt="Adicionar opcionais"
                                  style="margin-right: 5px; margin-top: -3px"
                                />Adicionar opcionais</span
                              >
                            </div>
                            <div
                              v-for="(beneficiario, i) in valordetalhes"
                              :key="i"
                              class="sec2-item-detalhe-other"
                            >
                              <div class="sec2-detalhes-plano">
                                <span>
                                  {{ beneficiario.nome }}
                                </span>
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Plano: </span>
                                <span
                                  v-if="beneficiario.valor && isLoading != true"
                                  style="font-weight: normal"
                                  >R$
                                  {{ formatMoney(beneficiario.valor) }}</span
                                >
                                <vue-content-loading
                                  v-if="isLoading != null && isLoading === true"
                                  :height="100"
                                  style="margin-left: 150px"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="600px"
                                    height="100px"
                                  />
                                </vue-content-loading>
                              </div>
                              <div
                                v-if="tipoorgaoentidade == 'Orgão'"
                                class="sec2-detalhes-plano"
                              >
                                <span>Auxílio: </span>
                                <span
                                  v-if="beneficiario.auxilio == 0 && isLoading != true"
                                  style="font-weight: normal"
                                  > R$
                                  {{ formatMoney(beneficiario.auxilio) }}</span
                                >
                                <span
                                  v-if="beneficiario.auxilio > 0 && isLoading != true"
                                  style="font-weight: normal"
                                  >- R$
                                  {{ formatMoney(beneficiario.auxilio) }}</span
                                >
                                <vue-content-loading
                                  :height="100"
                                  v-if="isLoading != null && isLoading === true"
                                  style="margin-left: 150px"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="600px"
                                    height="100px"
                                  />
                                </vue-content-loading>
                              </div>
                              <template v-if="beneficiario.opcionais != null">
                                <div
                                  v-for="(item, i) of beneficiario.opcionais"
                                  :key="i"
                                >
                                  <div
                                    v-if="item.selected == true"
                                    class="sec2-detalhes-plano"
                                  >
                                    <span
                                      >{{
                                        formataCapitalizado(item.nomeopcional)
                                      }}:
                                    </span>
                                    <span style="font-weight: normal"
                                      >+ R$
                                      {{
                                        formatMoney(item.valoropcional)
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </template>
                              <div class="sec2-detalhes-plano">
                                <span>Valor Total: </span>
                                <span v-if="beneficiario.auxilio > 0 && beneficiario.valor > 0 && isLoading != true">
                                  R$
                                  {{
                                    formatMoney(
                                      calculaPrecoFinal(
                                          beneficiario.total,
                                        i
                                      )
                                    )
                                  }}</span
                                >
                                <span v-else>
                                  R$
                                  {{
                                    formatMoney(
                                      calculaPrecoFinal(
                                          beneficiario.valor,
                                        i
                                      )
                                    )
                                  }}</span
                                >
                                <vue-content-loading
                                  :height="100"
                                  v-if="isLoading === true"
                                  style="margin-left: 150px"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="600px"
                                    height="100px"
                                  />
                                </vue-content-loading>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="container modal-plano modal-plano-mobile"
                      style="display: none"
                    >
                      <div class="row row-modal-plano">
                        <div class="col-sm-4 col-modal-plano-header">
                          <h4>Plano escolhido:</h4>
                        </div>
                        <div
                          class="col-sm-4 col-modal-plano"
                          style="padding-left: 0; padding-top: 0"
                        >
                          <div
                            class="row sec1-plano"
                            style="padding-left: 0; padding-top: 0"
                          >
                            <div class="col-sm-3 sec1-plano-img">
                              <img
                                style="width: 150px"
                                :src="
                                  listaOperadoras[
                                    operadoras[plano.frontoperadoraid]
                                      .operadoraprotheusid
                                  ].LOGO_OPERADORA
                                "
                              />
                              <div
                                class="ans-selo-div"
                                style="
                                  background: #fff;
                                  margin-top: 0 !important;
                                "
                              >
                                <span class="ans-selo-op"
                                  >ANS - Nº
                                  {{
                                    listaOperadoras[
                                      operadoras[plano.frontoperadoraid]
                                        .operadoraprotheusid
                                    ].ANS
                                  }}</span
                                >
                              </div>
                            </div>
                            <div
                              class="col-sm-12 sec1-plano-texto"
                              style="padding: 0"
                            >
                              {{ plano.descplano }}
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 col-modal-plano-header">
                          <h4>Informações:</h4>
                        </div>
                        <div class="col-sm-4 col-modal-plano">
                          <div class="sec2-plano">
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="map-marker-alt"
                                  class="icon-map-marker-alt"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Cobertura: </span>
                                {{ getAbrangencia(plano.cobertura) }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="bed"
                                  class="icon-bed"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Acomodação: </span>
                                {{ getAcomodacao(plano.acomodacao) }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user-friends"
                                  class="icon-user-friends"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Coparticipação: </span>
                                {{
                                  plano.coparticipacao == "0" ? "NÃO" : "SIM"
                                }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user"
                                  class="icon-user"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Idade Titular: </span>
                                {{
                                  calculateAge(
                                    datanasc.substr(6, 4) +
                                      "/" +
                                      datanasc.substr(3, 2) +
                                      "/" +
                                      datanasc.substr(0, 2)
                                  ) + " anos"
                                }}
                              </div>
                            </div>
                            <div
                              v-if="dependentes != null"
                              class="sec2-item-detalhe"
                            >
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user"
                                  class="icon-user"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Quantidade de dependentes: </span>
                                {{ dependentes.length }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="dollar-sign"
                                  class="icon-dollar-sign"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Valor do plano: </span>
                                {{ formatMoney(plano.valor) }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe">
                              <div class="sec2-icon-fa">
                                <svg
                                  width="16"
                                  height="18"
                                  viewBox="0 0 16 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.50006 3.9C10.2801 3.9 10.9401 4.75 11.0001 6H13.2101C13.1401 4.28 12.0901 2.7 10.0001 2.19V0H7.00006V2.16C6.47006 2.28 5.97006 2.46 5.52006 2.7L6.99006 4.17C7.40006 4 7.90006 3.9 8.50006 3.9ZM1.33006 1.06L0.0600586 2.33L3.50006 5.77C3.50006 7.85 5.06006 8.98 7.41006 9.68L10.9201 13.19C10.5801 13.67 9.87006 14.1 8.50006 14.1C6.44006 14.1 5.63006 13.18 5.52006 12H3.32006C3.44006 14.19 5.08006 15.42 7.00006 15.83V18H10.0001V15.85C10.9601 15.67 11.8201 15.3 12.4501 14.73L14.6701 16.95L15.9401 15.68L1.33006 1.06Z"
                                    fill="#B34A4E"
                                  />
                                </svg>
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Auxilio: </span>
                                {{ formatMoney(plano.valor_aux) }}
                              </div>
                            </div>
                            <div
                              class="sec2-item-detalhe"
                              style="
                                justify-content: space-between;
                                padding-right: 40px;
                              "
                            >
                              <div style="margin: 0; display: inherit">
                                <div
                                  class="sec2-icon-fa"
                                  style="margin-right: 20px"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.41 16.09V18H8.74V16.07C7.03 15.71 5.58 14.61 5.47 12.67H7.43C7.53 13.72 8.25 14.54 10.08 14.54C12.04 14.54 12.48 13.56 12.48 12.95C12.48 12.12 12.04 11.34 9.81 10.81C7.33 10.21 5.63 9.19 5.63 7.14C5.63 5.42 7.02 4.3 8.74 3.93V2H11.41V3.95C13.27 4.4 14.2 5.81 14.26 7.34H12.3C12.25 6.23 11.66 5.47 10.08 5.47C8.58 5.47 7.68 6.15 7.68 7.11C7.68 7.95 8.33 8.5 10.35 9.02C12.37 9.54 14.53 10.41 14.53 12.93C14.52 14.76 13.15 15.76 11.41 16.09Z"
                                      fill="#1DA090"
                                    />
                                  </svg>
                                </div>
                                <div class="sec3-plano" style="border: none">
                                  <h4>
                                    R$
                                    <strong>{{
                                      formatMoney(
                                        calculaPrecoReal(
                                          plano.valor - plano.valor_aux
                                        )
                                      )
                                    }}</strong
                                    ><span>/mês</span>
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 col-modal-plano-header">
                          <h4>Resumo do pedido:</h4>
                        </div>
                        <div class="col-sm-4 col-modal-plano">
                          <div class="sec2-plano">
                            <div
                              v-for="(beneficiario, i) in valordetalhes"
                              :key="i"
                              class="sec2-item-detalhe-other"
                            >
                              <div class="sec2-detalhes-plano">
                                <span>
                                  {{ beneficiario.nome }}
                                </span>
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Plano: </span>
                                <span
                                  v-if="beneficiario.valor > 0"
                                  style="font-weight: normal"
                                  >R$
                                  {{ formatMoney(beneficiario.valor) }}</span
                                >
                                <vue-content-loading
                                  :height="100"
                                  v-else
                                  style="margin-left: 150px"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="600px"
                                    height="100px"
                                  />
                                </vue-content-loading>
                              </div>
                              <div
                                v-if="tipoorgaoentidade == 'Orgão'"
                                class="sec2-detalhes-plano"
                              >
                                <span>Auxílio: </span>
                                <span
                                  v-if="beneficiario.auxilio > 0"
                                  style="font-weight: normal"
                                  >- R$
                                  {{ formatMoney(beneficiario.auxilio) }}</span
                                >
                                <vue-content-loading
                                  :height="100"
                                  v-else
                                  style="margin-left: 150px"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="600px"
                                    height="100px"
                                  />
                                </vue-content-loading>
                              </div>
                              <template v-if="beneficiario.opcionais != null">
                                <div
                                  v-for="(item, i) of beneficiario.opcionais"
                                  :key="i"
                                >
                                  <div
                                    v-if="item.selected == true"
                                    class="sec2-detalhes-plano"
                                  >
                                    <span
                                      >{{
                                        formataCapitalizado(item.nomeopcional)
                                      }}:
                                    </span>
                                    <span style="font-weight: normal"
                                      >+ R$
                                      {{
                                        formatMoney(item.valoropcional)
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </template>
                              <div class="sec2-detalhes-plano">
                                <span>Valor Total: </span>
                                <span v-if="beneficiario.valor > 0">
                                  R$
                                  {{
                                    formatMoney(
                                      calculaPrecoFinal(
                                          beneficiario.total,
                                        i
                                      )
                                    )
                                  }}</span
                                >
                                <vue-content-loading
                                  :height="100"
                                  v-else
                                  style="margin-left: 150px"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="600px"
                                    height="100px"
                                  />
                                </vue-content-loading>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template #modal-footer>
                      <b-button
                        class="btn-alianca pesquisar-planos pesquisar-planos-inverse"
                        @click="faleEquipe('modal-filtro-plano-' + index)"
                        >Fale com nossa equipe</b-button
                      >
                      <b-button
                        class="btn-alianca pesquisar-planos"
                        @click="
                          selectPlano(plano.planoid, plano.planoidprotheus)
                        "
                        >Comprar plano</b-button
                      >
                    </template>
                  </b-modal>
                  <b-modal :id="'modal-opcionais-plano-' + index">
                    <template #modal-header="{ close }">
                      <h5 class="title-modal">
                        Escolha as suas
                        <span style="color: #a01d22">coberturas</span>
                      </h5>
                      <b-button
                        class="close btn-close btn-modais-nohover"
                        aria-label="Close"
                        @click="
                          verificaPlanos(true, true);
                          close();
                        "
                        >×</b-button
                      >
                    </template>
                    <div class="row">
                      <div
                        v-for="(valord, j) in valordetalhes"
                        :key="j"
                        style="display: flex"
                      >
                        <div class="div-text-filter">
                          <h4 class="text-filter">
                            {{ completeText(valord.nome, 15) }}
                          </h4>
                        </div>
                        <div
                          v-for="(opcional, i) in valord.opcionais"
                          :key="i"
                          class="col col-sm-3 check-filter"
                          :class="{
                            'checked-filter': opcional.selected === true,
                          }"
                          style="
                            margin-left: 33px;
                            justify-content: space-between;
                          "
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="opcional.selected"
                          />
                          {{ opcional.nomeopcional }}
                          <b
                            >+{{
                              "R$" + formatMoney(opcional.valoropcional)
                            }}</b
                          >
                        </div>
                      </div>
                    </div>
                    <template #modal-footer="{ ok }">
                      <b-button class="btn-alianca btn-modais" @click="ok()"
                        >Adicionar ao plano</b-button
                      >
                    </template>
                  </b-modal>
                </b-col>
              </b-row>
              <b-col v-if="planosfiltered.length === 0">
                <div class="no-found-planos">
                  <h4>Não há planos que atendam os filtros selecionados :(</h4>
                  <p>Experimente limpar os filtros para exibir resultados</p>
                  <b-button
                    @click="limparFiltros()"
                    style="margin-left: 0px; width: 300px"
                    >Limpar filtros</b-button
                  >
                </div>
              </b-col>
            </b-container>

            <div
              class="div-btn-more"
              v-if="pagination < planosfiltered.length && !loadingcontent"
            >
              <b-button class="btn-alianca btn-more-planos" @click="nextpage"
                >Ver mais 6 planos de saúde</b-button
              >
            </div>

            <div v-if="countselectedplanos >= 2" id="compara-planos">
              <div class="container no-margin compara-planos-barra">
                <div class="row">
                  <div class="col-sm-8 col1-compara-planos no-margin">
                    <b-row>
                      <b-col
                        v-for="selectedplano in selectedplanos.filter(function (
                          u
                        ) {
                          return u.selected;
                        })"
                        :key="selectedplano.id"
                        style="margin: 0; padding: 0"
                      >
                        <div
                          v-if="selectedplano.selected == true"
                          class="plano-item"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :id="selectedplano.planoid"
                            v-model="
                              selectedplanos[selectedplano.planoid].selected
                            "
                            @change="verifyComparaPlanos(selectedplano.planoid)"
                          />
                          {{ selectedplano.planodesc }}
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div
                    class="col-sm-4 btn-compara planos col2-compara-planos no-margin"
                  >
                    <b-button
                      class="btn-alianca btn-modais"
                      v-b-modal.modal-comparativo-plano
                      >Comparar</b-button
                    >
                  </div>
                </div>
              </div>

              <div class="container no-margin compara-planos-barra-mobile">
                <div class="row">
                  <div
                    class="col-sm-12 col1-compara-planos no-margin col1-compara-planos-mobile"
                  >
                    <b-row>
                      <b-col
                        v-for="selectedplano in selectedplanos.filter(function (
                          u
                        ) {
                          return u.selected;
                        })"
                        :key="selectedplano.id"
                        style="margin: 0; padding: 0"
                      >
                        <div
                          v-if="selectedplano.selected == true"
                          class="plano-item"
                          style="margin-right: 0px"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :id="selectedplano.planoid"
                            v-model="
                              selectedplanos[selectedplano.planoid].selected
                            "
                            @change="verifyComparaPlanos(selectedplano.planoid)"
                          />
                          {{ "Plano " + selectedplano.planoid }}
                        </div>
                      </b-col>
                      <b-col>
                        <b-button
                          class="btn-alianca btn-modais"
                          v-b-modal.modal-comparativo-plano
                          >Comparar</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>

              <b-modal id="modal-comparativo-plano" class="modal-detalhe-plano">
                <template #modal-header="{ close }">
                  <b-button
                    class="close btn-close btn-modais-nohover"
                    aria-label="Close"
                    @click="close()"
                    >×</b-button
                  >
                </template>
                <b-row class="row-bootstrap-modal-compara">
                  <b-col
                    v-for="selectedplano in selectedplanos.filter(function (u) {
                      return u.selected;
                    })"
                    :key="selectedplano.id"
                    class="left-border"
                    style="margin: 0; padding: 0"
                  >
                    <div
                      v-if="selectedplano.selected == true"
                      class="container modal-plano"
                    >
                      <div class="row-modal-plano">
                        <div class="col-sm-12 col-modal-plano">
                          <div class="row sec1-plano">
                            <div
                              class="col-sm-3 sec1-plano-img"
                              style="margin-right: 20px"
                            >
                              <img
                                width="100%"
                                :src="
                                  listaOperadoras[
                                    operadoras[selectedplano.frontoperadoraid]
                                      .operadoraprotheusid
                                  ].LOGO_OPERADORA
                                "
                              />
                              <div
                                class="ans-selo-div"
                                style="
                                  background: #f2f2f2;
                                  margin-top: 0 !important;
                                "
                              >
                                <span class="ans-selo-op">
                                  ANS - Nº
                                  {{
                                    listaOperadoras[
                                      operadoras[selectedplano.frontoperadoraid]
                                        .operadoraprotheusid
                                    ].ANS
                                  }}
                                </span>
                              </div>
                            </div>
                            <div class="col-sm-8 sec1-plano-texto">
                              <p>
                                <b>{{
                                  "Plano " +
                                  operadoras[
                                    planos[selectedplano.planoid]
                                      .frontoperadoraid
                                  ].operadoraNome
                                }}</b>
                                {{ planos[selectedplano.planoid].descplano }}
                              </p>
                            </div>
                          </div>
                          <div style="margin: 0">
                            <b-button
                              class="btn-alianca pesquisar-planos"
                              @click="
                                selectPlano(
                                  planos[selectedplano.planoid].planoid,
                                  planos[selectedplano.planoid].planoidprotheus
                                )
                              "
                              >Comprar plano</b-button
                            >
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-modal-plano"
                          style="padding: 0; padding: 0"
                        >
                          <div
                            class="sec2-plano"
                            style="padding: 0; padding: 0"
                          >
                            <div class="sec2-item-detalhe top-border">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="map-marker-alt"
                                  class="icon-map-marker-alt"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Cobertura: </span>
                                {{
                                  getAbrangencia(
                                    planos[selectedplano.planoid].cobertura
                                  )
                                }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe top-border">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="bed"
                                  class="icon-bed"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Acomodação: </span>
                                {{
                                  getAcomodacao(
                                    planos[selectedplano.planoid].acomodacao
                                  )
                                }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe top-border">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user-friends"
                                  class="icon-user-friends"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Coparticipação: </span>
                                {{
                                  planos[selectedplano.planoid]
                                    .coparticipacao == "0"
                                    ? "NÃO"
                                    : "SIM"
                                }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe top-border">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="user"
                                  class="icon-user"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Idade: </span>
                                {{
                                  calculateAge(
                                    datanasc.substr(6, 4) +
                                      "/" +
                                      datanasc.substr(3, 2) +
                                      "/" +
                                      datanasc.substr(0, 2)
                                  ) + " anos"
                                }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe top-border">
                              <div class="sec2-icon-fa">
                                <font-awesome-icon
                                  icon="dollar-sign"
                                  class="icon-dollar-sign"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Valor do plano: </span>
                                {{
                                  formatMoney(
                                    planos[selectedplano.planoid].valor
                                  )
                                }}
                              </div>
                            </div>
                            <div class="sec2-item-detalhe top-border">
                              <div class="sec2-icon-fa">
                                <img
                                  src="@/assets/money-alt.svg"
                                  alt="Auxilio"
                                />
                              </div>
                              <div class="sec2-detalhes-plano">
                                <span>Auxilio: </span>
                                {{
                                  formatMoney(
                                    planos[selectedplano.planoid].valor_aux
                                  )
                                }}
                              </div>
                            </div>
                            <div
                              class="sec2-item-detalhe top-border"
                              style="
                                justify-content: space-between;
                                padding-right: 40px;
                              "
                            >
                              <div style="margin: 0; display: inherit">
                                <div class="sec2-icon-fa">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.41 16.09V18H8.74V16.07C7.03 15.71 5.58 14.61 5.47 12.67H7.43C7.53 13.72 8.25 14.54 10.08 14.54C12.04 14.54 12.48 13.56 12.48 12.95C12.48 12.12 12.04 11.34 9.81 10.81C7.33 10.21 5.63 9.19 5.63 7.14C5.63 5.42 7.02 4.3 8.74 3.93V2H11.41V3.95C13.27 4.4 14.2 5.81 14.26 7.34H12.3C12.25 6.23 11.66 5.47 10.08 5.47C8.58 5.47 7.68 6.15 7.68 7.11C7.68 7.95 8.33 8.5 10.35 9.02C12.37 9.54 14.53 10.41 14.53 12.93C14.52 14.76 13.15 15.76 11.41 16.09Z"
                                      fill="#1DA090"
                                    />
                                  </svg>
                                </div>
                                <div
                                  class="sec3-plano top-border"
                                  style="border: none"
                                >
                                  <h4>
                                    R$
                                    <strong>{{
                                      formatMoney(
                                        planos[selectedplano.planoid].valor -
                                          planos[selectedplano.planoid]
                                            .valor_aux
                                      )
                                    }}</strong
                                    ><span>/mês</span>
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <template #modal-footer><span></span></template>
              </b-modal>
            </div>
          </div>
        </transition>
      </div>
    </section>
    <div class="filtros-flutuante" v-if="filtrosmobile">
      <div class="item-menu">
        <p class="title">Escolha qual <span>Filtro</span></p>
        <span>
          <img
            src="@/assets/close.svg"
            alt="Fechar menu"
            @click="filtrosmobile = !filtrosmobile"
          />
        </span>
      </div>
      <div
        class="item-menu"
        @click="
          filtrosmobile = !filtrosmobile;
          $bvModal.show('modal-filtro-operadora');
        "
      >
        <p class="item">Filtrar por <span>Operadoras</span></p>
        <span>
          <img
            src="@/assets/arrow-right-planos.svg"
            alt="Filtrar por operadoras"
          />
        </span>
      </div>
      <div
        class="item-menu"
        @click="
          filtrosmobile = !filtrosmobile;
          $bvModal.show('modal-filtro-cobertura');
        "
      >
        <p class="item">Filtrar por <span>Coberturas</span></p>
        <span>
          <img
            src="@/assets/arrow-right-planos.svg"
            alt="Filtrar por coberturas"
          />
        </span>
      </div>
      <div
        class="item-menu"
        @click="
          filtrosmobile = !filtrosmobile;
          $bvModal.show('modal-filtro-more');
        "
      >
        <p class="item">Filtrar por <span>Outros filtros</span></p>
        <span>
          <img
            src="@/assets/arrow-right-planos.svg"
            alt="Filtrar por outros filtros"
          />
        </span>
      </div>
    </div>
    <div v-if="!adesaoFinalizada" style="margin: 0">
      <fale-conosco />
    </div>
    <modal-abandono-pagina v-if="!adesaoFinalizada" />
  </main>
</template>


<style lang="scss">
  .btn.btn-modais-nohover {
    margin: 0 !important;
    padding: 0 !important;

    &:hover {
      border: none !important;
    }

    &:focus {
      background: none;
      color: #1DA090 !important;
    }
  }
</style>

<script>
import VueContentLoading from "vue-content-loading";
import lerValorPlano from "@/services/lerValorPlano";
import lerValorAuxilio from "@/services/lerValorAuxilio";
import lerOpcionais from "@/services/lerOpcionais";
import lerValorPlanoOpcional from "@/services/lerValorPlanoOpcional";
import lerDataVigencia from "@/services/lerDataVigencia";
import Loading from "vue-loading-overlay";
import store from "@/store";

export default {
  name: "Seu-plano",
  components: {
    VueContentLoading,
    Loading,
  },
  data() {
    return {
      selected: "null",
      options: "",
      tipoorgaoentidade: "",
      planos: [],
      planosfiltered: [],
      operadoras: [],
      loadingcontent: true,
      filteroperadora: "Por operadoras",
      filtercobertura: "Por cobertura",
      filtermore: "Mais filtros",
      filtervalor: "Menor valor",
      activeentidadeorgao: 1,
      numerocontrato: 0,
      subfatura: 0,
      endcidade: "",
      enduf: "",
      selectedoperadoras: [],
      selectedplanos: [],
      countselectedplanos: 0,
      filtroscobertura: [],
      filtroshospitais: [
        { nome: "hospitalx1", valor: "Hospital CC Angélica", selected: false },
        { nome: "hospitaly1", valor: "Hospital CC Itaquera", selected: false },
        { nome: "hospitalz1", valor: "Hospital CC Lapa", selected: false },
        { nome: "hospitalx2", valor: "Hospital CC Angélica", selected: false },
        { nome: "hospitaly2", valor: "Hospital CC Itaquera", selected: false },
        { nome: "hospitalz2", valor: "Hospital CC Lapa", selected: false },
        { nome: "hospitalx3", valor: "Hospital CC Angélica", selected: false },
        { nome: "hospitaly3", valor: "Hospital CC Itaquera", selected: false },
        { nome: "hospitalz3", valor: "Hospital CC Lapa", selected: false },
        { nome: "hospitalx4", valor: "Hospital CC Angélica", selected: false },
        { nome: "hospitaly4", valor: "Hospital CC Itaquera", selected: false },
        { nome: "hospitalz4", valor: "Hospital CC Lapa", selected: false },
      ],
      filtrostipoplano: [],
      filtroscoparticipacao: [],
      filtrosacomodacao: [],
      pagination: 5,
      limitcomparacao: 3,
      precorange: [0, 100],
      fatormultiplicacaorange: 0,
      datanasc: store.getters.getAliancaDataNasc,
      filtrosmobile: false,
      textofiltrohospitais: "",
      abrangencialabels: [],
      acomodacaolabels: [],
      titular: store.getters.getAliancaNome,
      dependentes: store.getters.getAliancaObjDependentes,
      valordetalhes: [],
      exibeopcionais: false,
      nomeorgaoentidade: "",
      statusorgaoentidadewp: false,
      startmode: false,
      recheck: false,
      startlimite: true,
      limitehomerange: 0,
      ordenacaoselecionada: true,
      isLoading: false,
      obterDetalhesAnalisado: 0,
    };
  },
  methods: {
    faleEquipe(modal){
      this.$root.$emit('AbreFaleConosco');
      this.$bvModal.hide(modal);
    },
    disableStartRange() {
      if (this.precorange[1] > this.limitehomerange) this.startlimite = false;
      console.log("Foi alterado o Range");
    },
    formataCapitalizado(texto) {
      return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
    },
    checaValorRange(valor) {
      let menorvalor = 0;
      this.planos.map((obj) => {
        let valorfinal = this.calculaPrecoReal(obj.valor - obj.valor_aux);

        if (valorfinal < menorvalor) menorvalor = valorfinal;
        
      });
      return this.calculaPrecoReal(valor) + menorvalor;
    },
    calculaPrecoReal(valor) {
      for (let i = 0; i < this.valordetalhes.length; i++) {
        let opcionais = this.valordetalhes[i].opcionais;
        let accvalor = 0;

        if (opcionais != null) {
          for (const item of opcionais) {
            if (item.selected == true) accvalor += item.valoropcional;
          }
          valor += accvalor;
        }
      }
      return valor;
    },
    calculaPrecoFinal(valor, i) {
      let opcionais = this.valordetalhes[i].opcionais;

      if (opcionais != null) {
        let accvalor = 0;
        for (const item of opcionais) {
          if (item.selected == true) accvalor += item.valoropcional;
        }
        valor += accvalor;
      }

      return valor;
    },
    completeText(text, size) {
      if (text.length < size) {
        let diff = size - text.length;
        for (let i = 0; i < diff; i++) text += " ";
      } else {
        text = this.reduceText(text, size);
      }
      return text;
    },
    async prepareSelectOpcionais(opcionais, plano) {
      for (let i = 0; i < this.valordetalhes.length; i++) {
        let opcionaisselect = [];
        for (const opcional of opcionais) {
          let valoropcional = 0;
          if (i == 0) {
            valoropcional = await lerValorPlanoOpcional({
              tp_valor: "V",
              idOperadora: plano.codOperadora,
              numeroContrato: plano.bqc_numcon,
              versaoContrato: plano.bqc_vercon,
              numeroSubContrato: plano.bqc_subcon,
              versaoSubContrato: plano.bqc_versub,
              idPlano: plano.codPlano,
              versaoPlano: plano.bi3_versao,
              idPlanoOpcional: opcional.CODIGO_PLANO,
              versaoPlanoOpcional: opcional.VERSAO_PLANO,
              idadeBeneficiario: store.getters.getAliancaIdade,
              tipoUsuario: "T",
              grauParentesco: "C",
              ufTitular: store.getters.getAliancaEndUF,
            });
          } else {
            let datanasc = this.dependentes[i - 1].DataNascDep;
            datanasc =
              datanasc.substr(6, 4) +
              "/" +
              datanasc.substr(3, 2) +
              "/" +
              datanasc.substr(0, 2);

            let dataatual = new Date();
            let nascimento = new Date(datanasc);
            let diferenca = dataatual - nascimento;
            let idade = Math.floor(diferenca / 31557600000);

            valoropcional = await lerValorPlanoOpcional({
              tp_valor: "V",
              idOperadora: plano.codOperadora,
              numeroContrato: plano.bqc_numcon,
              versaoContrato: plano.bqc_vercon,
              numeroSubContrato: plano.bqc_subcon,
              versaoSubContrato: plano.bqc_versub,
              idPlano: plano.codPlano,
              versaoPlano: plano.bi3_versao,
              idPlanoOpcional: opcional.CODIGO_PLANO,
              versaoPlanoOpcional: opcional.VERSAO_PLANO,
              idadeBeneficiario: idade,
              tipoUsuario: "D",
              grauParentesco: this.dependentes[i - 1].GrauParentescoDep,
              ufTitular: store.getters.getAliancaEndUF,
            });
          }
          valoropcional = valoropcional.valor;
          opcionaisselect.push({
            codopcional: opcional.CODIGO_PLANO,
            versao_opcional: opcional.VERSAO_PLANO,
            nomeopcional: opcional.NOME_PLANO,
            valoropcional: valoropcional,
            selected: false,
          });
        }
        this.valordetalhes[i].opcionais = opcionaisselect;
      }
      return true;
    },
    async obterOpcionais(plano) {
      let opcionais = await lerOpcionais({
        idOperadora: plano.codOperadora,
        numeroContrato: plano.bqc_numcon,
        versaoContrato: plano.bqc_vercon,
        numeroSubContrato: plano.bqc_subcon,
        versaoSubContrato: plano.bqc_versub,
        idPlano: plano.codPlano,
        versaoPlano: plano.bi3_versao,
      });

      if (opcionais.length > 0) {
        return opcionais;
      }

      return null;
    },
    async obterDetalhes(planoid) {
      this.isLoading = true;
      let plano = this.planos.find(item => item.planoid === planoid);

      if (plano != null) {
        /*
          Pegar data de vigencia para as leituras de valores do plano
         */
        
        const { vigencia } = await lerDataVigencia({
          idOperadora: plano.codoperadora,
          numeroSubContrato: plano.bqc_subcon,
          codConvenio: this.planoFormatado[0].convenio
        })

        for (let i = 0; i < this.valordetalhes.length; i++) {
          if (i == 0) {

            let valorplano = await lerValorPlano({
              idOperadora: plano.codoperadora,
              numeroContrato: plano.bqc_numcon,
              versaoContrato: plano.bqc_vercon,
              numeroSubContrato: plano.bqc_subcon,
              versaoSubContrato: plano.bqc_versub,
              idPlano: plano.planoidprotheus,
              versaoPlano: plano.bi3_versao,
              datBas: vigencia,
              idadeBeneficiario: store.getters.getAliancaIdade,
              tipoUsuario: "T",
              grauParentesco: "C",
              ufTitular: store.getters.getAliancaEndUF,
            });
            this.valordetalhes[i].valor = valorplano.valor;

            if (this.tipoorgaoentidade == "Orgão") {
              let today = new Date();
              today =
                today.getFullYear() +
                "" +
                (today.getMonth() + 1) +
                "" +
                today.getDate();

              let valorauxilio = await lerValorAuxilio({
                codRegra: store.getters.getAliancaCodAux,
                codPla: plano.codPlano,
                tipUsu: "T",
                idade: store.getters.getAliancaIdade,
                vl_plano: plano.valor,
                codRem: store.state.AliancaFaixaRemuneracaoSelecionada.zzp_codrem,
                tpServ: store.state.AliancaFaixaRemuneracaoSelecionada.zzp_tpserv,
                valIni: store.getters.getAliancaFaixaRemuneracao.minimo,
                valFin: store.getters.getAliancaFaixaRemuneracao.maximo,
                dt_atual: today,
                vl_pl_base: "0.00",
              });
              console.log('tipo plano 1', plano.tipo)
              
              if (plano.tipo === 'DENTAL') {
                this.valordetalhes[i].auxilio = 0;
                this.valordetalhes[i].total = valorplano.valor;
              }else{
                if (valorauxilio.valor > valorplano.valor){
                  this.valordetalhes[i].auxilio = valorplano.valor;
                  this.valordetalhes[i].total = 0;
                }
                else {
                  this.valordetalhes[i].auxilio = valorauxilio.valor;
                  this.valordetalhes[i].total = valorplano.valor - valorauxilio.valor;
                }
              }
            }
          } else {
            let datanasc = this.dependentes[i - 1].DataNascDep;
            datanasc =
              datanasc.substr(6, 4) +
              "/" +
              datanasc.substr(3, 2) +
              "/" +
              datanasc.substr(0, 2);

            let dataatual = new Date();
            let nascimento = new Date(datanasc);
            let diferenca = dataatual - nascimento;
            let idade = Math.floor(diferenca / 31557600000);

            let valorplano = await lerValorPlano({
              idOperadora: plano.codoperadora,
              numeroContrato: plano.bqc_numcon,
              versaoContrato: plano.bqc_vercon,
              numeroSubContrato: plano.bqc_subcon,
              versaoSubContrato: plano.bqc_versub,
              idPlano: plano.planoidprotheus,
              versaoPlano: plano.bi3_versao,
              datBas: vigencia,
              idadeBeneficiario: idade,
              tipoUsuario: "D",
              grauParentesco: this.dependentes[i - 1].GrauParentescoDep,
              ufTitular: store.getters.getAliancaEndUF,
            });
            this.valordetalhes[i].valor = valorplano.valor;

            if (this.tipoorgaoentidade == "Orgão") {
              let today = new Date();
              today =
                today.getFullYear() +
                "" +
                (today.getMonth() + 1) +
                "" +
                today.getDate();

              let valorauxilio = await lerValorAuxilio({
                codRegra: store.getters.getAliancaCodAux,
                codPla: plano.codPlano,
                tipUsu: "D",
                idade: idade,
                vl_plano: plano.valor,
                codRem: store.state.AliancaFaixaRemuneracaoSelecionada.zzp_codrem,
                tpServ: store.state.AliancaFaixaRemuneracaoSelecionada.zzp_tpserv,
                valIni: store.getters.getAliancaFaixaRemuneracao.minimo,
                valFin: store.getters.getAliancaFaixaRemuneracao.maximo,
                dt_atual: today,
                vl_pl_base: "0.00",
              });

              
              console.log('tipo plano 2', plano.tipo)
              if (plano.tipo === 'DENTAL') {
                this.valordetalhes[i].auxilio = 0;
                this.valordetalhes[i].total = valorplano.valor;
              }else{
                if (valorauxilio.valor > valorplano.valor){
                  this.valordetalhes[i].auxilio = valorplano.valor;
                  this.valordetalhes[i].total = 0;
                }
                else {
                  this.valordetalhes[i].auxilio = valorauxilio.valor;
                  this.valordetalhes[i].total = valorplano.valor - valorauxilio.valor;
                }
              }
            }
          }
        }

        let opcionais = await this.obterOpcionais(plano);
        if (opcionais != null) {
          let liberaopcionais = await this.prepareSelectOpcionais(
            opcionais,
            plano
          );
          if (liberaopcionais) this.exibeopcionais = true;
        }
      } else {
        console.log("Problema ao encontrar plano selecionado");
      }
      this.isLoading = false;
    },
    limparFiltros() {
      this.selectedoperadoras = this.selectedoperadoras.map((obj) => {
        obj.selected = false;
        return obj;
      });

      this.filtroscobertura = this.filtroscobertura.map((obj) => {
        obj.selected = false;
        return obj;
      });

      this.filtrosacomodacao = this.filtrosacomodacao.map((obj) => {
        obj.selected = false;
        return obj;
      });

      this.filtrostipoplano = this.filtrostipoplano.map((obj) => {
        obj.selected = false;
        return obj;
      });

      this.precorange[1] = 100;

      this.aplicafiltros();
    },
    ativaOrdenacao() {
      this.startmode = false;
      this.ordenacaoselecionada = true;
    },
    orderlista() {
      if (!this.startmode) {
        if (this.filtervalor == "Menor valor") {
          this.planosfiltered = this.planosfiltered.sort((a, b) => {
            let fa = a.valor + a.valor_aux;
            let fb = b.valor + b.valor_aux;
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
            // return fa - fb
          });
          this.filtervalor = "Maior valor";
        } else {
          this.planosfiltered = this.planosfiltered.sort((a, b) => {
            let fa = a.valor + a.valor_aux;
            let fb = b.valor + b.valor_aux;
            if (fa > fb) {
              return -1;
            }
            if (fa < fb) {
              return 1;
            }
            return 0;
            // return fb - fa
          });
          this.filtervalor = "Menor valor";
        }
      }
    },
    async aplicafiltros(maisplanos = false) {
      this.planosfiltered = this.planos.filter((obj) => {
        let accfilter = false;
        let accselected = 0;

        for (let i = 0; i < this.selectedoperadoras.length; i++) {
          if (this.selectedoperadoras[i].selected) {
            accselected++;
            accfilter =
              accfilter ||
              (this.selectedoperadoras[i].operid === obj.frontoperadoraid
                ? true
                : false);
          }
        }

        if (accselected == 0) return true;
        return accfilter;
      });

      this.planosfiltered = this.planosfiltered.filter((obj) => {
        let accfilter = false;
        let accselected = 0;

        for (let i = 0; i < this.filtroscobertura.length; i++) {
          let tmpobj = [];
          if (this.filtroscobertura[i].selected) {
            accselected++;
            tmpobj["cobertura"] = this.filtroscobertura[i].nome;
            for (let key in obj) {
              for (let keyfilter in tmpobj) {
                if (key == keyfilter)
                  accfilter =
                    accfilter ||
                    (obj[key] === tmpobj[keyfilter] ? true : false);
              }
            }
          }
        }

        if (accselected == 0) return true;
        return accfilter;
      });

      this.planosfiltered = this.planosfiltered.filter((obj) => {
        let accfilter = false;
        let accselected = 0;

        for (let i = 0; i < this.filtrostipoplano.length; i++) {
          let tmpobj = [];
          if (this.filtrostipoplano[i].selected) {
            accselected++;
            tmpobj["tipo"] = this.filtrostipoplano[i].nome;
            for (let key in obj) {
              for (let keyfilter in tmpobj) {
                if (key == keyfilter)
                  accfilter =
                    accfilter ||
                    (obj[key] === tmpobj[keyfilter] ? true : false);
              }
            }
          }
        }

        if (accselected == 0) return true;
        return accfilter;
      });

      this.planosfiltered = this.planosfiltered.filter((obj) => {
        let accfilter = false;
        let accselected = 0;

        for (let i = 0; i < this.filtroscoparticipacao.length; i++) {
          let tmpobj = [];
          if (this.filtroscoparticipacao[i].selected) {
            accselected++;
            tmpobj["coparticipacao"] = this.filtroscoparticipacao[i].nome;
            for (let key in obj) {
              for (let keyfilter in tmpobj) {
                if (key == keyfilter)
                  accfilter =
                    accfilter ||
                    (obj[key] === tmpobj[keyfilter] ? true : false);
              }
            }
          }
        }

        if (accselected == 0) return true;
        return accfilter;
      });

      this.planosfiltered = this.planosfiltered.filter((obj) => {
        let accfilter = false;
        let accselected = 0;

        for (let i = 0; i < this.filtrosacomodacao.length; i++) {
          let tmpobj = [];
          if (this.filtrosacomodacao[i].selected) {
            accselected++;
            tmpobj["acomodacao"] = this.filtrosacomodacao[i].nome.toString();
            for (let key in obj) {
              for (let keyfilter in tmpobj) {
                if (key == keyfilter)
                  accfilter =
                    accfilter ||
                    (obj[key] === tmpobj[keyfilter] ? true : false);
              }
            }
          }
        }

        if (accselected == 0) return true;
        return accfilter;
      });

      this.planosfiltered = this.planosfiltered.filter((obj) => {
        let finalvalor = this.calculaPrecoReal(obj.valor - obj.valor_aux); // Ajustes
        let valmin = this.checaValorRange(
          this.precorange[0] * this.fatormultiplicacaorange
        );
        let valmax = this.checaValorRange(
          this.precorange[1] * this.fatormultiplicacaorange
        );
        if (finalvalor >= valmin && finalvalor <= valmax) return true;
        return false;
      });

      /* this.planosfiltered = this.planosfiltered.filter( (obj) => {
          if ( obj.valor == 0 || obj.valor_aux == 0 ) return false 
          return true
        }) */

      this.filtervalor = "Menor valor";
      this.orderlista();
      if (!maisplanos) this.pagination = 5;
    },
    async selectPlano(id, protheusid) {
      let selectedplano = this.planos[id];
      this.isLoading = true;
        await this.obterDetalhes(id);
      if (this.obterDetalhesAnalisado == 0)
        await this.obterDetalhes(id);

      let getOperadoraObj = this.operadoras[selectedplano.frontoperadoraid];
      let getValorDetalhes = { detalhes: this.valordetalhes };
      selectedplano.frontoperadoraid = getOperadoraObj;
      selectedplano = { ...selectedplano, ...getValorDetalhes };
      console.log(selectedplano);
      store.commit("mutAliancaSelectedPlano", selectedplano);
      store.commit("mutAliancaSelectedPlanoProtheus", protheusid);
      this.progressup_comparar();
      this.isLoading = false;
      this.$router.push("cadastrar");
    },
    nextpage() {
      this.pagination = this.pagination + 6;
      this.verificaPlanos(true);
    },
    verifyComparaPlanos(checkbox) {
      if (this.selectedplanos[checkbox].selected == true) {
        this.countselectedplanos++;
      } else {
        this.countselectedplanos--;
      }
    },
    reduceText(text, len) {
      if (text && text.length < len) return text;
      return text ? text.substring(0, len - 3) + "..." : text;
    },
    calculateAge(date) {
      let currentDate = new Date();
      let birthDate = new Date(date);
      let difference = currentDate - birthDate;
      let age = Math.floor(difference / 31557600000);
      return age;
    },
    formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : "")
        );
      } catch (e) {
        console.log(e);
      }
    },
    randOp() {
      return Math.ceil(Math.random() * this.operadoras.length) - 1;
    },
    changeActiveEntidadeOrgao(view) {
      this.activeentidadeorgao = view;
    },
    getAbrangencia(id) {
      return this.abrangencialabels[parseInt(id, 10)];
    },
    getAcomodacao(id) {
      return this.acomodacaolabels[id.toString()];
    },
    async getOperadoras(nomeoperadora, codoperadoraprotheus) {
      let inseridas = [];

      this.operadoras.map((obj) => {
        if (inseridas.indexOf(obj.operadoraprotheusid) === -1)
          inseridas.push(obj.operadoraprotheusid);
      });

      if (inseridas.indexOf(codoperadoraprotheus) === -1) {
        this.operadoras.push({
          operadoraNome: nomeoperadora.replace("\u00e7\u00e3", "çã"),
          slug: "",
          content: "",
          operadoraLogo: codoperadoraprotheus,
          operadoraANS: codoperadoraprotheus,
          operadoraDesc: "",
          showFooter: "",
          operadoraLink: "",
          operadoraprotheusid: codoperadoraprotheus,
        });
        this.selectedoperadoras.push({
          operid: this.selectedoperadoras.length,
          opernome: nomeoperadora.replace("\u00e7\u00e3", "çã"),
          selected: false,
        });
        inseridas.push(codoperadoraprotheus);
      }
    },
    getOperadoraIdFront(cod) {
      for (let i = 0; i < this.operadoras.length; i++) {
        if (this.operadoras[i].operadoraprotheusid == cod) return i;
      }
    },
    syncPlanosObj(planos) {
      console.log("Sincronizando objeto de planos com planos possíveis...");

      for (let i = this.planos.length; i < planos.length; i++) {
        // this.planos = [] e let i = 0
        // let valorauxreal =
        //   planos[i].valor < planos[i].valor_aux ? 0 : planos[i].valor_aux;

        this.getOperadoras(planos[i].operadoraid, planos[i].codoperadora);
        this.planos.push({
          codoperadora: planos[i].codoperadora,
          bqc_numcon: planos[i].bqc_numcon,
          bqc_subcon:  planos[i].bqc_subcon,
          bqc_vercon:  planos[i].bqc_vercon,
          bqc_versub:  planos[i].bqc_versub,
          bi3_versao: planos[i].bi3_versao,
          planoid: i,
          planoidprotheus: planos[i].planoid,
          operadoraid: planos[i].operadoraid,
          descplano: planos[i].descplano,
          cobertura: planos[i].cobertura,
          tipo: planos[i].tipo,
          acomodacao: planos[i].acomodacao,
          coparticipacao: planos[i].coparticipacao,
          valor: planos[i].valor,
          valor_aux: planos[i].valor_aux,
          frontoperadoraid: this.getOperadoraIdFront(planos[i].codoperadora),
        });
        if (i >= this.selectedplanos.length)
          this.selectedplanos.push({
            planoid: i,
            planodesc: planos[i].descplano.replace("\u00e7\u00e3", "çã"),
            selected: false,
            frontoperadoraid: this.getOperadoraIdFront(planos[i].codoperadora),
          });
      }

      if (this.planoFormatado.length > 1) {
        this.loadingcontent = false;
      }

      let menorvalor = 0;
      let maiorvalor = 0;
      this.planos.map((obj) => {
        let valorfinal = this.calculaPrecoReal(obj.valor - obj.valor_aux);

        if (valorfinal < menorvalor) menorvalor = valorfinal;
        else if (menorvalor == 0) menorvalor = valorfinal;

        if (valorfinal > maiorvalor) maiorvalor = valorfinal;
      });

      let storagelimite = JSON.parse(sessionStorage.getItem("alianca_ecommerce"));
      let limiteFormatado = storagelimite.AliancaMaximoPreco + 1
      let limite = Math.round((limiteFormatado * 100) / 100)
      console.log('limiteFormatado', limite)

      this.fatormultiplicacaorange = (limite - 0) / 100;
      console.log('this.fatormultiplicacaorange', this.fatormultiplicacaorange)

      // Logica de limitador da home - x = round(( limite - minimo ) / passo)
      // let limite = sessionStorage.getItem("AliancaMaxPreco");
      if (limite != null && this.startlimite) {
        if (menorvalor < limite && limite < maiorvalor) {
          let rangelimite = Math.floor(
            (limite - menorvalor) / this.fatormultiplicacaorange
          );
          this.precorange[1] = rangelimite;
          this.limitehomerange = rangelimite;
        }
      }
    },
    preparaFiltros() {
      let abrangenciasexistentes = [];
      this.planos.map((obj) => {
        if (abrangenciasexistentes.indexOf(obj.cobertura) === -1)
          abrangenciasexistentes.push(obj.cobertura);
      });

      let abrangenciasinseridas = [];
      this.filtroscobertura.map((obj) => abrangenciasinseridas.push(obj.nome));
      this.abrangencialabels.forEach((element, index) => {
        if (index < 10) index = "0" + index;
        if (
          abrangenciasinseridas.indexOf(index) === -1 &&
          abrangenciasexistentes.indexOf(index) !== -1
        ) {
          abrangenciasinseridas.push(index);
          this.filtroscobertura.push({
            nome: index,
            valor: element,
            selected: false,
          });
        }
      });

      let acomodacoesexistentes = [];
      this.planos.map((obj) => {
        if (acomodacoesexistentes.indexOf(obj.acomodacao.toString()) === -1)
          acomodacoesexistentes.push(obj.acomodacao.toString());
      });

      let acomodacoesinseridas = [];
      this.filtrosacomodacao.map((obj) =>
        acomodacoesinseridas.push(obj.nome.toString())
      );
      this.acomodacaolabels.forEach((element, index) => {
        if (
          acomodacoesinseridas.indexOf(index.toString()) === -1 &&
          acomodacoesexistentes.indexOf(index.toString()) !== -1
        ) {
          acomodacoesinseridas.push(index.toString());
          this.filtrosacomodacao.push({
            nome: index,
            valor: element,
            selected: false,
          });
        }
      });

      let coparticipacoesexistentes = [];
      this.planos.map((obj) => {
        if (
          coparticipacoesexistentes.indexOf(obj.coparticipacao.toString()) ===
          -1
        )
          coparticipacoesexistentes.push(obj.coparticipacao.toString());
      });
      let coparticipacaolabels = ["NÃO", "SIM"];

      let coparticipacoesinseridas = [];
      this.filtroscoparticipacao.map((obj) =>
        coparticipacoesinseridas.push(obj.nome.toString())
      );
      coparticipacaolabels.forEach((element, index) => {
        if (
          coparticipacoesinseridas.indexOf(index.toString()) === -1 &&
          coparticipacoesexistentes.indexOf(index.toString()) !== -1
        ) {
          coparticipacoesexistentes.push(index.toString());
          this.filtroscoparticipacao.push({
            nome: index.toString(),
            valor: element,
            selected: false,
          });
        }
      });

      let filtrostipo = [];
      let filtrosinseridos = [];
      this.filtrostipoplano.map((obj) => filtrosinseridos.push(obj.nome));
      this.planos.map((obj) => {
        if (filtrostipo.indexOf(obj.tipo) === -1) {
          filtrostipo.push(obj.tipo);
          if (filtrosinseridos.indexOf(obj.tipo) === -1) {
            filtrosinseridos.push(obj.tipo);
            this.filtrostipoplano.push({
              nome: obj.tipo,
              valor: "PLANO " + obj.tipo,
              selected: false,
            });
          }
        }
      });
    },
    verificaPlanos(flag = false, delay = false) {
      if (delay) this.loadingcontent = true;
      let statusanalise = store.getters.getAliancaStatusAnalise;
      let planos = this.planoFormatado;
      this.loadingcontent = true;

      this.syncPlanosObj(planos);
      this.preparaFiltros();
      this.aplicafiltros(flag);

      if (!statusanalise) {
        if (planos.length >= 6) {
          this.recheck = true;
        } else {
          console.log("Ainda não há planos na lista formatada");
        }
      } else {
        this.recheck = false;
      }

      if (this.recheck && !this.ordenacaoselecionada)
        window.setTimeout(() => {
          this.reChecarPlanos(flag);
          console.log("Verificando planos novamente...");
        }, 1000);
    },
    verificaPlanosWatcher(delay = false) {
      if (delay) this.loadingcontent = true;

      let statusanalise = store.getters.getAliancaStatusAnalise;
      let planos = this.planoFormatado;
      this.loadingcontent = true;

      this.syncPlanosObj(planos);
      this.aplicafiltros(true);

      if (!statusanalise) {
        if (planos.length >= 6) {
          this.recheck = true;
        } else {
          console.log("Ainda não há planos na lista formatada");
        }
      } else {
        this.recheck = false;
      }
    },

    reChecarPlanos(flag) {
      this.verificaPlanos(flag, false);
    },
    uftoestado(uf) {
      let estados_json =
        '{"AC":"Acre","AL":"Alagoas","AP":"Amapá","AM":"Amazonas","BA":"Bahia","CE":"Ceará","DF":"Distrito Federal","ES":"Espírito Santo","GO":"Goiás","MA":"Maranhão","MT":"Mato Grosso","MS":"Mato Grosso do Sul","MG":"Minas Gerais","PR":"Paraná","PB":"Paraíba","PA":"Pará","PE":"Pernambuco","PI":"Piauí","RN":"Rio Grande do Norte","RS":"Rio Grande do Sul","RJ":"Rio de Janeiro","RO":"Rondônia","RR":"Roraima","SC":"Santa Catarina","SE":"Sergipe","SP":"São Paulo","TO":"Tocantins"}';
      let estados = JSON.parse(estados_json);
      return estados[uf];
    },
    async prepareSimuladorPlanos() {
      this.abrangencialabels =
        store.getters.getAliancaPlanosFiltrosAbrangencias;
      this.acomodacaolabels = store.getters.getAliancaPlanosFiltrosAcomodacoes;

      await this.verificaPlanosWatcher();

      this.valordetalhes.push({
        nome: store.getters.getAliancaNome,
        valor: 0,
        auxilio: 0,
        total: 0,
        opcionais: null,
      });
      if (this.dependentes != null) {
        for (const item of this.dependentes) {
          this.valordetalhes.push({
            nome: item.NomeDep,
            valor: 0,
            auxilio: 0,
            total: 0,
            opcionais: null,
          });
        }
      }
    },
    progressup_comparar() {
      document
        .getElementById("step-progress-point3")
        .classList.add("rounded-point-progress-ok");
      document.getElementById("step-progress").value = 66.69;
    },
  },
  computed: {
    adesaoFinalizada() {
      return this.$route.name === 'adesao-finalizada';
    },
    planoFormatado() {
      return store.getters.getAliancaPlanosListaFormatado;
    },
    entidadeorgaoinfo() {
      return store.getters.getAliancaPlanosEntidadeorgaoInfo;
    },
    listaOperadoras() {
      return store.getters.getAliancaPlanosOperadoras;
    },
  },
  watch: {
    async planoFormatado() {
      this.verificaPlanosWatcher();

      if (this.planoFormatado.length > 1) {
        this.loadingcontent = false;
      }
    },
  },
  mounted() {
    document.getElementById("step-progress").value = 45;
    document
      .getElementById("step-progress-point1")
      .classList.add("rounded-point-progress-ok");
    document
      .getElementById("step-progress-point2")
      .classList.add("rounded-point-progress-ok");
    document
      .getElementById("globaletapa2")
      .classList.remove("etapas-progresso-texto-disabled");

    for (let i = 1; i <= 4; i++) {
      document
        .getElementById("globaletapam" + i)
        .classList.remove("etapas-progresso-mobile-show");
      document
        .getElementById("globaletapaprox" + i)
        .classList.remove("div-proximo-etapa-mobile-show");
    }
    document
      .getElementById("globaletapam2")
      .classList.add("etapas-progresso-mobile-show");
    document
      .getElementById("globaletapaprox2")
      .classList.add("div-proximo-etapa-mobile-show");

    document.getElementById("header").classList.add("header-fixed");
    document
      .getElementById("header-seu-plano")
      .classList.add("header-filtros-fixed");
    document
      .getElementById("content-seu-plano")
      .classList.add("pos-content-fixed");
  },
  created() {
    let funcpublico = store.getters.getAliancaFuncPub;
    if (funcpublico != null) {
      let planoselecionado = store.getters.getAliancaSelectedPlano;
      if (planoselecionado != null) {
        this.$router.push("cadastrar");
      } else {
        if (funcpublico == "Sim") {
          this.tipoorgaoentidade = "Orgão";
        } else {
          this.tipoorgaoentidade = "Entidade";
        }

        if (this.entidadeorgaoinfo.length == 0) {
          if (this.tipoorgaoentidade == "Orgão")
            this.nomeorgaoentidade = store.getters.getAliancaOrgaoPub;
          else this.nomeorgaoentidade = store.getters.getAliancaEntidadeClasse;
          console.log('entidade', this.nomeorgaoentidade);
        } else {
          this.nomeorgaoentidade = this.entidadeorgaoinfo[0].titulo;
          this.statusorgaoentidadewp = true;
        }

        this.endcidade = this.formataCapitalizado(
          store.getters.getAliancaEndCidade
        );
        this.enduf = store.getters.getAliancaEndUF;

        this.prepareSimuladorPlanos();
      }
    } else {
      this.$router.push("simule-aqui");
    }
  },
};
</script>